import PropTypes from "prop-types";
import React from "react";
import { Table } from "react-bootstrap";
import { FormattedMessage, intlShape } from "react-intl";
import { currencyFormatterFactory } from "../utils";
import { memberCoverageTypes } from "../../members/member/coverage/enums";


const getDescription = (intl, line, memberClassName) => {
  if (line.guarantee.guaranteeType === "PRICE_LIST") {
    const translatedCoverageType = intl.formatMessage({
      id: memberCoverageTypes.find(c => c.value == line.coverageType).key,
    });
    return `${line.guaranteeName} - ${memberClassName} - ${translatedCoverageType}`;
  } else {
    return line.guaranteeName;
  }
};

export const PremiumSimulatorDetailsTable = (
  { items, subtotal, taxes, total, memberClassName },
  { intl }
) => {
  const formatCurrency = currencyFormatterFactory(intl);
  return (
    <div className="resultsDetailsTable">
      <Table condensed hover>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="clients.client.premiumSimulator.results.details.description" />
            </th>
            <th className="currency">
              <FormattedMessage id="clients.client.premiumSimulator.results.details.employeePart" />
            </th>
            <th className="currency">
              <FormattedMessage id="clients.client.premiumSimulator.results.details.employerPart" />
            </th>
            <th className="currency">
              <FormattedMessage id="clients.client.premiumSimulator.results.details.cost" />
            </th>
            <th className="currency">
              <FormattedMessage id="clients.client.premiumSimulator.results.details.taxes" />
            </th>
          </tr>
        </thead>
        <tbody>
          {items.map((line, index) => {
            const description = getDescription(
              intl,
              line,
              memberClassName
            );
            return (
              <tr key={index}>
                <td>{description}</td>
                <td className="currency">
                  {formatCurrency(line.employeePart)}
                </td>
                <td className="currency">
                  {formatCurrency(line.employerPart)}
                </td>
                <td className="currency">{formatCurrency(line.subtotal)}</td>
                <td className="currency">{formatCurrency(line.taxes)}</td>
              </tr>
            );
          })}
          <tr>
            <td colSpan="2" />
            <td>
              <FormattedMessage id="clients.client.premiumSimulator.results.details.subtotals" />
            </td>
            <td className="currency">{formatCurrency(subtotal)}</td>
            <td className="currency">{formatCurrency(taxes)}</td>
          </tr>
          <tr>
            <td colSpan="2" />
            <td className="totals">
              <FormattedMessage id="clients.client.premiumSimulator.results.details.total" />
            </td>
            <td className="totals" />
            <td className="currency totals">{formatCurrency(total)}</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

PremiumSimulatorDetailsTable.contextTypes = {
  intl: intlShape,
};

PremiumSimulatorDetailsTable.propTypes = {
  items: PropTypes.array,
  subtotal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  taxes: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  memberClassName: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/results/DetailsTable.js